package org.vreo.devicehub.features.core.presentation

import kotlin.math.roundToInt

/**
 * Round float to specified number of decimals.
 *
 * @param decimals number of decimals to round to, default is 2
 * @return rounded float
 */
fun Float.roundToDecimals(decimals: Int = 2): Float {
    var dotAt = 1
    repeat(decimals) { dotAt *= 10 }
    val roundedValue = (this * dotAt).roundToInt()
    return (roundedValue / dotAt) + (roundedValue % dotAt).toFloat() / dotAt
}

fun Double.roundToDecimals(decimals: Int = 2): Float {
    var dotAt = 1
    repeat(decimals) { dotAt *= 10 }
    val roundedValue = (this * dotAt).roundToInt()
    return (roundedValue / dotAt) + (roundedValue % dotAt).toFloat() / dotAt
}